import React from 'react';

const AllAumReportData = ({ allReportsData, convertFormet }) => {

    // Function to calculate the total cases and loan amounts from dpd_reports
    const calculateDpdTotal = (dpdReports) => {
        return dpdReports.reduce(
            (acc, dpd_report) => {
                const totalCases = Number(dpd_report.dpd_count); // Ensure it's a number
                const loanAmount = Number(dpd_report.loan_amount); // Ensure it's a number (nulls will be 0)
                return {
                    totalCases: acc.totalCases + (isNaN(totalCases) ? 0 : totalCases),
                    loanAmount: acc.loanAmount + (isNaN(loanAmount) ? 0 : loanAmount),
                };
            },
            { totalCases: 0, loanAmount: 0 }
        );
    };

    // Function to calculate totals for running cases, closed cases, etc.
    const calculateTotal = (reportValue, innerReportValue) => {
        return allReportsData.reduce((sum, report) => {
            const runningCases = report?.data?.[reportValue]?.[innerReportValue];
            const count = Number(runningCases);
            return sum + (isNaN(count) ? 0 : count);
        }, 0);
    };

    const convertFormetStatic = (val) => `₹${Number(val).toLocaleString()}`;

    return (
        <>
            {allReportsData.map((reportData, index) => {
                // Calculate the total cases and loan amount for DPD reports
                const dpdTotal = calculateDpdTotal(reportData.data.dpd_reports);

                return (
                    <div className="p-4 md:p-8 overflow-x-auto" key={index}>
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-gray-800 font-semibold">Report Details</h2>
                            <span className="text-gray-800 font-semibold">DATE: {new Date().toLocaleDateString()}</span>
                        </div>

                        {/* DPD Report Table */}
                        <table className="w-full border text-sm">
                            <thead>
                                <tr className="bg-gray-100 text-gray-700">
                                    <th className="p-3 border">DOMAIN NAME</th>
                                    <th className="p-3 border">AUM</th>
                                </tr>
                            </thead>
                            <tbody>
                                {/* DPDs Total */}
                                <tr className="font-medium">
                                    <td className="p-3 border text-black font-medium">DPDs</td>
                                    <td>
                                        <span className="font-medium text-black">Total Cases: </span>{dpdTotal.totalCases}<br />
                                        <span className="font-medium text-black">Loan Amt: </span>{convertFormet(dpdTotal.loanAmount)}
                                    </td>
                                </tr>

                                {/* Individual DPD Reports */}
                                {reportData.data.dpd_reports.map((dpd_report, index) => (
                                    <tr key={index}>
                                        <td className="p-3 border text-black font-medium">{dpd_report.label}</td>
                                        <td className="p-3 border">
                                            <span className="font-medium text-black">Total Cases: </span>{dpd_report.dpd_count}<br />
                                            <span className="font-medium text-black">Loan Amt: </span>
                                            {convertFormet(dpd_report.loan_amount)}
                                        </td>
                                    </tr>
                                ))}

                                {/* Running Cases */}
                                <tr className="font-medium">
                                    <td className="p-3 border text-black font-medium">Running</td>
                                    <td className="p-3 border">
                                        <span className="font-medium text-black">Total Cases: </span>{reportData.data["running_cases"]["Running Cases"]}<br />
                                        <span className="font-medium text-black">Loan Amt: </span>
                                        {convertFormet(reportData.data["running_cases"]["Loan Amount"] ?? 0)}
                                    </td>
                                </tr>

                                {/* Grand Total */}
                                <tr className="font-semibold bg-gray-50">
                                    <td className="p-3 border text-black font-medium">Grand Total</td>
                                    <td className="p-3 border">
                                        <span className="font-medium text-black">Total Cases: </span><br />
                                        <span className="font-medium text-black">Loan Amt: </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        {/* AUM and Bank Balance Table */}
                        <table className="w-full border text-sm mt-6">
                            <thead className="bg-gray-100 text-gray-700">
                                <tr>
                                    <th className="p-3 border">AUM</th>
                                    <th className="p-3 border">BANK BALANCE</th>
                                    <th className="p-3 border">LOAN AMT POS</th>
                                    <th className="p-3 border">REPAYM AMT POS</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="text-center">
                                    <td className="p-3 border"></td>
                                    <td className="p-3 border"></td>
                                    <td className="p-3 border font-semibold">7570700</td>
                                    <td className="p-3 border font-semibold">9295450</td>
                                </tr>
                            </tbody>
                        </table>

                        {/* Closed, Part Payment, and Grand Total Table */}
                        <table className="w-full border text-sm mt-6">
                            <tbody>
                                <tr>
                                    <td className="p-3 border text-black font-medium"></td>
                                    <td className="p-3 border text-center text-black font-medium">Cases</td>
                                    <td className="p-3 border text-center text-black font-medium">Loan-Amount</td>
                                    <td className="p-3 border text-center text-black font-medium">Repayment-Amount</td>
                                </tr>
                                <tr>
                                    <td className="p-3 border text-black font-medium">Closed</td>
                                    <td className="p-3 border text-center">{reportData.data['closed_cases']['closed_cases']}</td>
                                    <td className="p-3 border text-center">{convertFormet(reportData.data['closed_cases']['loan_amount'])}</td>
                                    <td className="p-3 border text-center">{convertFormet(reportData.data['closed_cases']['repayment_amount'])}</td>
                                </tr>
                                <tr>
                                    <td className="p-3 border text-black font-medium">Part-Payment</td>
                                    <td className="p-3 border text-center">{reportData.data['part_payment']['cases']}</td>
                                    <td className="p-3 border text-center">{convertFormet(reportData.data['part_payment']['loan_amount'])}</td>
                                    <td className="p-3 border text-center">{convertFormet(reportData.data['part_payment']['repayment_amount'])}</td>
                                </tr>
                                <tr>
                                    <td className="p-3 border text-black font-medium">Grand-Total</td>
                                    <td className="p-3 border text-center">
                                        {Number(reportData.data['closed_cases']['closed_cases']) + Number(reportData.data['part_payment']['cases'])}
                                    </td>
                                    <td className="p-3 border text-center">
                                        {convertFormet(Number(reportData.data['closed_cases']['loan_amount']) + Number(reportData.data['part_payment']['loan_amount']))}
                                    </td>
                                    <td className="p-3 border text-center">
                                        {convertFormet(Number(reportData.data['closed_cases']['repayment_amount']) + Number(reportData.data['part_payment']['repayment_amount']))}
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                );
            })}

            {/* Combined Grand Total Summary Table */}
            <div className="p-4 md:p-8 mt-8 bg-white border border-gray-200 rounded-xl shadow-md">
                <h2 className="text-xl font-semibold mb-6 text-[#1D3E50]">Combined Grand Total Summary</h2>
                <div className="overflow-x-auto">
                    <table className="min-w-full bg-white border border-gray-300 rounded-md overflow-hidden shadow-sm">
                        <thead style={{ backgroundColor: '#1D3E50' }}>
                            <tr>
                                <th className="px-4 py-3 text-left text-white font-semibold text-sm whitespace-nowrap">Category</th>
                                <th className="px-4 py-3 text-left text-white font-semibold text-sm text-center whitespace-nowrap">Total Cases</th>
                                <th className="px-4 py-3 text-left text-white font-semibold text-sm text-center whitespace-nowrap">Loan Amount</th>
                                <th className="px-4 py-3 text-left text-white font-semibold text-sm text-center whitespace-nowrap">Repayment Amount</th>
                            </tr>
                        </thead>
                        <tbody className="text-gray-800 text-sm">
                            <tr className="border-t border-gray-300 hover:bg-[#EDF2F5]">
                                <td className="px-4 py-3 border font-medium text-[#1D3E50] whitespace-nowrap">DPD Totals</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">18</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">{convertFormetStatic(800000)}</td>
                                <td className="px-4 py-3 border text-center text-gray-500 italic whitespace-nowrap">—</td>
                            </tr>
                            <tr className="border-t border-gray-300 hover:bg-[#EDF2F5]">
                                <td className="px-4 py-3 border font-medium text-[#1D3E50] whitespace-nowrap">Running Cases</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">{calculateTotal('running_cases', 'Running Cases')}</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">{convertFormet(calculateTotal('running_cases', 'Loan Amount'))}</td>
                                <td className="px-4 py-3 border text-center text-gray-500 italic whitespace-nowrap">—</td>
                            </tr>
                            <tr className="border-t border-gray-300 hover:bg-[#EDF2F5]">
                                <td className="px-4 py-3 border font-medium text-[#1D3E50] whitespace-nowrap">Closed Cases</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">{calculateTotal('closed_cases', 'closed_cases')}</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">{convertFormet(calculateTotal('closed_cases', 'loan_amount'))}</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">{convertFormet(calculateTotal('closed_cases', 'repayment_amount'))}</td>
                            </tr>
                            <tr className="border-t border-gray-300 hover:bg-[#EDF2F5]">
                                <td className="px-4 py-3 border font-medium text-[#1D3E50] whitespace-nowrap">Part Payment</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">{calculateTotal('part_payment', 'cases')}</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">{convertFormet(calculateTotal('part_payment', 'loan_amount'))}</td>
                                <td className="px-4 py-3 border text-center">{convertFormet(calculateTotal('part_payment', 'repayment_amount'))}</td>
                            </tr>
                            <tr className="border-t font-semibold" style={{ backgroundColor: '#F5F8FA' }}>
                                <td className="px-4 py-3 border text-[#1D3E50]">Grand Totals (Closed + Part Payment)</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">—</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">—</td>
                                <td className="px-4 py-3 border text-center whitespace-nowrap">—</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
}

export default AllAumReportData;
